import loadProductRecentlyViewedModule from './modules/ProductRecentlyViewed.module';
import loadWishListModule from './modules/WishList.module';
import loadCompareModule from './modules/Compare.module';
const loadProductRecentlyViewedRootModule = () => ({
    hasRouter: false,
    modules: [loadCompareModule(), loadProductRecentlyViewedModule(), loadWishListModule()],
});
export default loadProductRecentlyViewedRootModule;
